/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

function updateCookieExpiration(cookieName, days) {
  const cookieValue = getCookie(cookieName);
  if (cookieValue) {
    deleteCookie(cookieName, '.ecomgraduates.com');
    setCookie(cookieName, cookieValue, days, '.ecomgraduates.com');
  }
}

function getCookie(cookieName) {
  const name = cookieName + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i].trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return "";
}

function setCookie(cookieName, cookieValue, days, domain) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Expiration in days
  const expires = "expires=" + date.toUTCString();
  const domainString = domain ? `domain=${domain};` : '';
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/;" + domainString;
}

function deleteCookie(cookieName, domain) {
  const domainString = domain ? `domain=${domain};` : '';
  document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;" + domainString;
}

updateCookieExpiration('ref', 1);


// Navbar - Adjust navbar-brand
const navbarBrandSubtitle = document.querySelector('#navbar-desktop .navbar-brand .subtitle')
if (navbarBrandSubtitle) {
    window.addEventListener('scroll', (e) => {
        if (window.scrollY > 0) {
            navbarBrandSubtitle.style.display = 'block'
        } else {
            navbarBrandSubtitle.style.display = 'none'
        }
    })
}

function delay(callback, ms) {
  let timer = 0;
  return function() {
    let context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
}

  (function() {
    'use strict';

    // UTM parameters to track
    const UTM_PARAMS = [
        'utm_source',
        'utm_medium', 
        'utm_campaign',
        'utm_term',
        'utm_content',
        'utm_id',
        '_kx' // Klaviyo specific parameter
    ];

    // Function to get URL parameters
    function getUrlParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    // Function to capture and add UTM parameters to cart note
    function captureAndAddUtmToNote() {
        const utmData = {};
        let hasUtmData = false;

        // Check for each UTM parameter in current URL
        UTM_PARAMS.forEach(param => {
            const value = getUrlParameter(param);
            if (value) {
                utmData[param] = decodeURIComponent(value);
                hasUtmData = true;
            }
        });

        // If we found UTM parameters, add them to cart note
        if (hasUtmData) {
            // Add landing page info
            utmData.landing_page = window.location.href;
            
            // Format UTM data for note
            const utmNote = formatUtmNote(utmData);
            
            // Update cart note
            updateCartNote(utmNote);
            
            console.log('UTM parameters captured and added to cart note:', utmData);
        }
    }

    // Function to format UTM data as a readable note
    function formatUtmNote(utmData) {
        const lines = ['--- UTM Tracking ---'];
        
        Object.keys(utmData).forEach(key => {
            if (key === 'landing_page') {
                lines.push(`Landing Page: ${utmData[key]}`);
            } else if (key === '_kx') {
                lines.push(`Klaviyo ID: ${utmData[key]}`);
            } else {
                const label = key.replace('utm_', '').replace(/^\w/, c => c.toUpperCase());
                lines.push(`${label}: ${utmData[key]}`);
            }
        });
        
        lines.push('--- End UTM ---');
        return lines.join('\n');
    }

    // Function to update cart note via API
    function updateCartNote(utmNote) {
        if (typeof fetch === 'undefined') return;

        // First get current cart to check existing note
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let newNote = utmNote;
                
                // If there's already a note, append UTM data (unless UTM data already exists)
                if (cart.note && !cart.note.includes('--- UTM Tracking ---')) {
                    newNote = cart.note + '\n\n' + utmNote;
                } else if (cart.note && cart.note.includes('--- UTM Tracking ---')) {
                    // UTM data already exists, don't add again
                    console.log('UTM data already exists in cart note');
                    return;
                }

                // Update cart note
                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        note: newNote
                    })
                });
            })
            .then(response => {
                if (response && response.ok) {
                    console.log('UTM data added to cart note');
                }
            })
            .catch(e => {
                console.error('Failed to update cart note:', e);
            });
    }

    // Function to add UTM data to note form fields
    function addUtmToNoteForms(utmNote) {
        // Look for cart note fields and update them
        const noteFields = document.querySelectorAll('textarea[name="note"], input[name="note"]');
        
        noteFields.forEach(field => {
            if (field.value && !field.value.includes('--- UTM Tracking ---')) {
                field.value = field.value + '\n\n' + utmNote;
            } else if (!field.value) {
                field.value = utmNote;
            }
        });

        // Also add hidden input for forms that don't have note fields
        const cartForms = document.querySelectorAll('form[action="/cart"], form[action*="/cart/add"]');
        cartForms.forEach(form => {
            if (!form.querySelector('input[name="note"], textarea[name="note"]')) {
                let input = form.querySelector('input[name="utm_note"]');
                if (!input) {
                    input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'note';
                    form.appendChild(input);
                }
                input.value = utmNote;
            }
        });
    }

    // Function to send UTM data to Shopify Analytics
    function sendToShopifyAnalytics(utmData) {
        if (typeof ShopifyAnalytics === 'undefined') return;

        try {
            ShopifyAnalytics.lib.track('UTM Parameters Captured', {
                utm_source: utmData.utm_source || '',
                utm_medium: utmData.utm_medium || '',
                utm_campaign: utmData.utm_campaign || '',
                utm_term: utmData.utm_term || '',
                utm_content: utmData.utm_content || '',
                utm_id: utmData.utm_id || '',
                klaviyo_id: utmData._kx || '',
                landing_page: utmData.landing_page || ''
            });
        } catch (e) {
            console.error('Failed to send UTM data to Shopify Analytics:', e);
        }
    }

    // Initialize the tracking
    function init() {
        // Only run if there are UTM parameters in the URL
        const hasUtmParams = UTM_PARAMS.some(param => getUrlParameter(param));
        
        if (hasUtmParams) {
            // Wait for DOM to be ready
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', captureAndAddUtmToNote);
            } else {
                captureAndAddUtmToNote();
            }
        }
    }

    // Debug function to check current cart note
    window.debugUtmTracking = function() {
        if (typeof fetch !== 'undefined') {
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    console.log('Current Cart Note:');
                    console.log(cart.note || 'No note');
                    
                    // Check if UTM data is present
                    if (cart.note && cart.note.includes('--- UTM Tracking ---')) {
                        console.log('✅ UTM data found in cart note');
                    } else {
                        console.log('❌ No UTM data in cart note');
                    }
                })
                .catch(e => console.error('Failed to fetch cart:', e));
        }
    };

    // Function to clear cart note
    window.clearCartNote = function() {
        if (typeof fetch !== 'undefined') {
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    note: ''
                })
            }).then(response => {
                if (response.ok) {
                    console.log('Cart note cleared');
                }
            }).catch(e => {
                console.error('Failed to clear cart note:', e);
            });
        }
    };

    // Start the tracking
    init();

})();

// document.addEventListener('DOMContentLoaded', function() {
//   let storeUrlInputs = document.querySelectorAll('input[name="properties[Store Url]"]');
//   console.log('Store URL inputs:', storeUrlInputs);

//   storeUrlInputs.forEach(function(input) {
//     // Create alert element
//     let alertElement = document.createElement('div');
//     alertElement.className = 'alert alert-danger mt-2 d-none';
//     alertElement.role = 'alert';
//     alertElement.textContent = 'Not a valid Shopify store. Please try again.';
//     input.parentNode.insertBefore(alertElement, input.nextSibling);

//     let alertTimeout;

//     function showAlert() {
//       alertElement.classList.remove('d-none');
//       clearTimeout(alertTimeout);
//       alertTimeout = setTimeout(() => {
//         alertElement.classList.add('d-none');
//       }, 5000); // Hide alert after 5 seconds
//     }

//     function hideAlert() {
//       alertElement.classList.add('d-none');
//       clearTimeout(alertTimeout);
//     }

//     input.addEventListener('keyup', delay(function (e) {
//       let value = this.value.trim();
//       console.log('Current value:', value);

//       if (value === '') {
//         hideAlert();
//         return; // Exit early if input is empty
//       }

//       // Remove protocol if present
//       value = value.replace(/^(https?:\/\/)?(www\.)?/i, '');

//       // Remove path if present
//       value = value.split('/')[0];

//       console.log('Cleaned value:', value);

//       console.log('Attempting to fetch from:', 'https://' + value + '/meta.json');
//       fetch('https://' + value + '/meta.json')
//         .then(response => {
//           if (!response.ok) {
//             throw new Error('Not a valid Shopify store');
//           }
//           return response.json();
//         })
//         .then(data => {
//           console.log('Fetch data:', data);
//           if (data.myshopify_domain) {
//             console.log('Myshopify domain:', data.myshopify_domain);
//             this.value = data.myshopify_domain;
//             hideAlert();
//           } else {
//             throw new Error('Not a valid Shopify store');
//           }
//         })
//         .catch(error => {
//           console.error('Error:', error);
//           this.value = ''; // Clear the input
//           showAlert();
//         });
//     }, 500));
//   });
// });